const handleEmpties = (a: any, b: any): number | 'no matches' => {
  if (!a && !b) return 0
  if (!a) return -1
  if (!b) return 1
  return 'no matches'
}

export const StringComparator = (a: string, b: string, nodeA: any, nodeB: any, isDescending: boolean): number => {
  const earlyReturn = handleEmpties(a, b)
  if (earlyReturn === 'no matches') {
    return a?.toLowerCase().localeCompare(b?.toLowerCase())
  } else {
    return earlyReturn
  }
}
